module.exports = __webpack_public_path__ + "img/advg.d7ea9c2b.png";